import React from 'react';
import type { InputBlockType } from '~/components/page/Forms/components/Builder/utils/typeguards/isInputTypeBlock';
import BlockLayout from '../BlockLayout';
import LocalesInput from '../LocalesInput';
import Dropdown, { type OptionOf } from '~/components/molecule/Dropdown';
import ToggleCheckbox from '~/components/molecule/ToggleCheckbox';
import Catalog from '~/Catalog';
import { BLOCK_OPTIONS, type ScreenNodeBlock_FE } from '../../constants';
import isContactBlock from '~/components/page/Forms/components/Builder/utils/typeguards/isContactBlock';

type Props = {
  onChange: (next: InputBlockType) => void;
  nodeId: string;
  block: InputBlockType;
};

const text = {
  overwriteField: 'Huidige waarde van contact overschrijven',
  required: Catalog.requiredField,
  changeInputType: 'Invoertype wijzigen',
};

const componentsToSelect: Array<ScreenNodeBlock_FE> = [
  'FormData_Input_Email',
  'FormData_Input_Integer',
  'FormData_Input_Multiline',
  'FormData_Input_Text',
  'FormData_Input_Address',
];

const selectComponentOptions: Array<OptionOf<string>> = BLOCK_OPTIONS.filter(
  option => componentsToSelect.includes(option.payload),
);

const InputForType: React.FCC<Props> = ({ onChange, nodeId, block }) => (
  <BlockLayout blockKey={block.key} nodeId={nodeId}>
    {!isContactBlock(block.__typename) && (
      <Dropdown
        onChange={option =>
          onChange({ ...block, __typename: option.option.payload })
        }
        options={selectComponentOptions}
        selectedOptionIdx={selectComponentOptions.findIndex(
          opt => opt.payload === block.__typename,
        )}
        label={text.changeInputType}
      />
    )}
    <LocalesInput
      block={block}
      onChange={onChange}
      subject="label"
      blockKey={block.key}
      nodeId={nodeId}
    />
    <ToggleCheckbox
      label={text.required}
      size="small"
      value={block.required}
      onChange={() => onChange({ ...block, required: !block.required })}
      containerProps={{
        justification: 'space-between',
        direction: 'row',
        align: 'center',
        width: '100%',
      }}
      disabled={block.__typename === 'FormData_Input_Contact_Email'}
    />
    {isContactBlock(block.__typename) && 'overwrites' in block && (
      <ToggleCheckbox
        label={text.overwriteField}
        size="small"
        value={block.overwrites}
        onChange={() => onChange({ ...block, overwrites: !block.overwrites })}
        containerProps={{
          justification: 'space-between',
          direction: 'row',
          align: 'center',
          width: '100%',
        }}
      />
    )}
  </BlockLayout>
);

export default InputForType;
